/* eslint-disable @typescript-eslint/ban-ts-ignore */
import * as React from "react";
import { Route, Redirect } from "react-router-dom";
import { RouteProps } from "react-router";
import UserStore from "state/user";
// Utilities and hooks
import { get } from "lodash";
import { observer, inject } from "mobx-react";
import { getRedirectPath } from "helpers/history";

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
interface IProps extends RouteProps {
	path: string;
	props?: any;
	component: React.ElementType;
	user?: UserStore;
}
const PrivateRoute: React.FC<IProps> = ({
	component: Component,
	props: authenticatedComponentProps,
	user,
	...rest
}) => {
	// Show the component only when the user is logged in
	// Otherwise, redirect the user to /auth/login page
	return (
		<Route
			{...rest}
			render={props => {
				// @ts-ignore
				const redirect = getRedirectPath(props);
				return get(user, ["isLoggedIn"]) ? (
					<Component {...props} {...authenticatedComponentProps} />
				) : (
					<Redirect to={`/auth/login?redirect=${redirect}`} />
				);
			}}
		/>
	);
};

export default inject("user")(observer(PrivateRoute));
